import { createContext, useContext } from 'react';

/**
 * Lets a field tell its form that a dictation is still writing into it. The
 * form does not save meanwhile: the field holds DeepL's provisional words, and
 * the final text — and its translation — would be lost to them.
 *
 * `report(true)` when a dictation starts, `report(false)` when it ends. Null
 * outside a form that cares (nothing to block there).
 */
export const DictationBusyContext = createContext<
    ((busy: boolean) => void) | null
>(null);

export function useDictationBusyReport(): ((busy: boolean) => void) | null {
    return useContext(DictationBusyContext);
}
